import "bootstrap-sass";
import { render } from "react-dom";
import React from "react";

import SearchProvider from "../providers/SearchProvider";

import { trackClick, trackGoal } from "../shared/helpers/gtm_tracking";
import UserTiming from "../shared/helpers/user-timing";

// from common.js
import autocompleteToggle from "../components/autocomplete/AutocompleteToggle.js";
import embedYoutube from "../components/video.js";
import initGeneralEnquiry from "../components/enquiries/general_enquiry";
import initNamedEnquiry from "../components/enquiries/named_enquiry";
import scrollspy from "../components/scrollspy/scrollspy.js";

import mountNewsletterForm from "../controllers/Newsletter.jsx";
import mountPopovers from "../controllers/Popover.jsx";

import notifier from "../shared/helpers/airbrake";
import ellipsis from "../shared/helpers/ellipsis";
import emarsys from "../shared/helpers/emarsys";

import "../shared/helpers/defer-picture";
import "../shared/helpers/responsive-bg";
import '../shared/gtm-script-loader';
import '../shared/notifications';

import "./common.scss";
// end from common.js

import "../scripts/sections/blocks/autocomplete";
import "../components/shared/video_gallery";

import "./search.scss";

const userTiming = new UserTiming({ src: "search" });

// from common.js
function handleClickTracking() {
  document.addEventListener("click", e => {
    const target = e.target.closest(".gtm-track-click");

    if (target) {
      trackClick(target);
    }
  });
}

// end from common.js

function fixSubNav() {
  const subnav = document.querySelector("[data-scrollspy]");

  if (subnav && subnav.nodeName.toLowerCase() !== "nav") {
    const div = document.createElement("div");
    const nav = document.createElement("nav");
    const ul = document.createElement("ul");
    const links = subnav.querySelectorAll("a");

    links.forEach(link => {
      const li = document.createElement("li");

      li.appendChild(link);
      ul.appendChild(li);
    });
    ul.classList.add("list-bare");
    div.classList.add("wrapper");
    div.appendChild(ul);
    nav.dataset.scrollspy = "";
    nav.appendChild(div);

    subnav.parentNode.replaceChild(nav, subnav);
  }
}

function showReadMore(e) {
  e.preventDefault();

  const content = document.querySelector(".js-region-content");

  if (content) {
    content.classList.remove("is-collapsed");
  }
}

function addReadMoreHandler() {
  const readMore = document.querySelector(".js-read-more");

  if (readMore) {
    readMore.addEventListener("click", showReadMore);
  }
}

function onDOMContentLoaded() {
  userTiming.start("onDOMContentLoaded");

  // from common.js
  autocompleteToggle();
  initGeneralEnquiry();
  initNamedEnquiry();
  handleClickTracking();
  ellipsis();
  embedYoutube();
  mountNewsletterForm();
  mountPopovers();
  fixSubNav(); // have to do this before `scrollSpy` just in case the HTML is incorrect
  scrollspy();

  // end from common.js

  trackGoal("VIEWED_REGION");
  addReadMoreHandler();
  render(<SearchProvider />, document.getElementById("js-search-results"));

  userTiming.finish("onDOMContentLoaded");
}

document.addEventListener("DOMContentLoaded", onDOMContentLoaded);

// from common.js
window.addEventListener("error", error => {
  notifier.notify({ error });
});

emarsys(window.emarsysData);
// end from common.js

userTiming.finish();



// WEBPACK FOOTER //
// ./entry_points/search.js